import React from 'react';
import { Radio, Tooltip } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';

interface IProps {
  selectionMode: string;
  onSelectionChange: (e: RadioChangeEvent) => void;
  hasSeries: boolean;
}

const seriesNote = (
  <div style={{ marginTop: 8, color: 'rgba(0,0,0,0.65)' }}>
    <ul style={{ paddingLeft: 18 }}>
      <li>
          When selected, the title will be tagged as Exclude Entire Series.
      </li>
      <li>
          Future titles from this series will be automatically sent to the Exclusion List.
      </li>
      <li>
          Other titles from the author that are not part of this series will not be sent
          to the Exclusion List.
      </li>
    </ul>
  </div>
);

const Ao3ExcludeOptions: React.FC<IProps> = ({
  selectionMode,
  onSelectionChange,
  hasSeries
}) => (
  <div style={{ marginBottom: 12 }}>
    <Radio.Group
      value={selectionMode}
      onChange={onSelectionChange}
    >
      <Radio value='title'>Exclude this title</Radio>

      <div style={{ marginTop: 12 }}>
        <Radio value='series' disabled={!hasSeries}>
          <Tooltip
            title={hasSeries ? '' : 'This title is not associated with a series'}
            placement='right'
          >
            <span>Exclude an entire series</span>
          </Tooltip>
          {seriesNote}
        </Radio>
      </div>
    </Radio.Group>
  </div>
);

export default Ao3ExcludeOptions;
